import { render } from "./XmlAttribute.vue?vue&type=template&id=3c430bce&scoped=true"
import script from "./XmlAttribute.vue?vue&type=script&lang=js"
export * from "./XmlAttribute.vue?vue&type=script&lang=js"

import "./XmlAttribute.vue?vue&type=style&index=0&id=3c430bce&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.21_webpack@5.91.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c430bce"]])

export default __exports__